;
define("global_views_back_to_top.tpl", function(){});

